module.exports = __webpack_public_path__ + "img/art-test-icon3.0820e0f8.png";